import Layout from "./layout";
import { Button, Box } from "@mui/material";
import { useNavigate } from 'react-router-dom';// Page linking using this 

const EventandStaffDash  = () => {
    const navigate = useNavigate();// Page linking using this 

   
    return(
        <>  
        <Layout/>
        <h1 className="title">Create Event</h1>
        <Box
                sx={{display: 'flex',justifyContent: 'center',alignItems: 'center',height: '50vh', gap: '8em', }}
            >
                <Button 
                    variant="contained"
                    onClick={() => {navigate('/issue-categorymain') }}
                    sx={{backgroundColor: '#0A64A2', color: '#fff',left:'2em', borderRadius:'0.4em' ,marginRight: '2em',padding: '35px 53px',fontSize: '14px',fontWeight: 'bold',fontFamily: ' sans-serif',
                    }}   
                >
                   Event Category
                </Button>
                    
                <Button
                    variant="contained" onClick={() => {navigate('/Issue-evntbrand') }} // Page linking using this 
                    sx={{backgroundColor: '#0A64A2',color: '#fff',padding: '36px 90px',fontSize: '14px',borderRadius:'0.4em' ,fontWeight: 'bold',fontFamily: ' sans-serif',
                    }}
                >
                  Event
                </Button>
            </Box>

        </>
    )
}
export default EventandStaffDash;   

 